(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("irc-framework", [], factory);
	else if(typeof exports === 'object')
		exports["irc-framework"] = factory();
	else
		root["irc-framework"] = factory();
})(window, function() {
return 